import { useEffect, useState } from "react";
import { NoNewsLanding } from "./NoNewsLanding";
import ConditionalRender from "../../../ConditionalRender";
import BannerImage from "./assets/newsLandingBanner.png";
import BulbIcon from "../../../assets/Bulb.svg";
import SampleNewsArticle from "../../../assets/SampleNewsArticle.png";

import { apiAgent } from "../../../axiosConfig";
import { useHistory } from "react-router";
import NewsFeed from "../news_feed/news_feed";
import { Link } from "react-router-dom";
import { HelpCenterLinks } from "../support_views/help_center/HelpCenterPage";
import { Icons } from "../../../design_system/components/Icons";

const NewsLanding = (props) => {
    const [prospectsStatus, setProspectsStatus] = useState(null);
    const history = useHistory();

    useEffect(() => {
        apiAgent({
            method: "get",
            url: "/team/status",
        })
            .then((res) => {
                setProspectsStatus(res.data);
            })
            .catch((err) => {
                setProspectsStatus({ prospect_status: "prospect_data_needed", feed_status: "no_feed" });
            });
    }, []);
    if (!prospectsStatus) return null;
    if (prospectsStatus.feed_status == "feed_present") {
        return <NewsFeed displaySearchBar={true} trackAnalytics={true}/>;
    }
    if (
        prospectsStatus.prospect_status == "prospect_data_present" &&
        prospectsStatus.feed_status == "no_feed"
    )
        return <NoNewsLanding />;

    return (
        <div className="news-landing-layout">
            <img src={BannerImage} className="news-landing-banner" />
            <ConditionalRender
                if={prospectsStatus.prospect_status == "prospect_data_needed"}
            >
                <div className="headline-l-bold news-landing-status-title">
                    Get news when your prospects get mentioned
                </div>
                <div className="news-landing-upload-prompt">
                    <a href="/import_prospects" className="body-l-bold news-landing-upload-link">
                        Upload a list of prospects
                    </a>
                    <span> to get started</span>
                </div>
            </ConditionalRender>
            <ConditionalRender
                if={prospectsStatus.prospect_status == "prospect_data_processing"}
            >
                <div className="headline-l-bold news-landing-status-title">
                    Your news is getting fetched. Please wait for sometime
                </div>
            </ConditionalRender>
            <div className="news-landing-guide-card">
                <div className="flex items-center news-landing-guide-header">
                    <img src={BulbIcon} className="news-landing-guide-icon" />
                    <div className="body-l-bold news-landing-guide-title">Getting Started</div>
                </div>
                <div className="news-landing-guide-divider"></div>
                <div className="news-landing-guide-body">
                    <div className="flex items-start mb-m news-landing-step-row">
                        <div className="flex justify-center items-center flex-shrink-0 body-s-bold news-landing-step-num">{prospectsStatus.prospect_status == "prospect_data_processing" ? <Icons name="success_status" size={24} /> : 1}</div>
                        <div className="news-landing-step-content">
                            <div className="body-m-bold news-landing-step-title">
                                Upload prospect data
                            </div>
                            <div className="body-s news-landing-step-desc">
                                Upload a list of your prospects (People or
                                organizations). You can add them individually or
                                bulk import them from a csv file.
                            </div>
                            <div className="flex flex-wrap news-landing-step-links">
                                <Link
                                    to={"/import_prospects"}
                                    className="link-default news-landing-step-link"
                                    target="_blank"
                                >
                                    Import prospect data <Icons name="chevron-right" size={24} />
                                </Link>
                                {/* <Link
                                    to={HelpCenterLinks["Adding Prospects"]}
                                    className="text-link news-landing-step-link"
                                    target="_blank"
                                >
                                    Learn more about importing data &gt;
                                </Link>
                                <Link
                                    to={HelpCenterLinks["Privacy Policy"]}
                                    className="text-link news-landing-step-link"
                                    target="_blank"
                                >
                                    Read our data security policy &gt;
                                </Link> */}
                            </div>
                        </div>
                    </div>

                    <div className="flex items-start mb-m news-landing-step-row">
                        <div className="flex justify-center items-center flex-shrink-0 body-s-bold news-landing-step-num">2</div>
                        <div>
                            <div className="body-m-bold news-landing-step-title">
                                Getting news results
                            </div>
                            <div className="body-s news-landing-step-desc">
                                We know you’d like to see results immediately. Our news tracker analyzes your data across multiple keyword sets to deliver accurate results, so updates may take some time after you upload your prospect data.
                            </div>
                            {/* <div className="news-landing-step-links">
                                <Link
                                    to={HelpCenterLinks["Keywords"]}
                                    className="text-link news-landing-step-link"
                                    target="_blank"
                                >
                                    Learn more about keywords &gt;
                                </Link>
                                <a
                                    href={SampleNewsArticle}
                                    target="_blank"
                                    className="text-link news-landing-step-link"
                                >
                                    See sample news article &gt;
                                </a>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewsLanding;
